
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectDetailsWithoutImages"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectDetails"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"floors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FloorDetailsWithoutImages"},"directives":[]}]}}]}}],"loc":{"start":0,"end":202}};
    doc.loc.source = {"body":"#import './FloorDetailsWithoutImages.graphql'\n#import './ProjectDetails.graphql'\n\nfragment ProjectDetailsWithoutImages on Project {\n  ...ProjectDetails\n  floors {\n    ...FloorDetailsWithoutImages\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./FloorDetailsWithoutImages.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ProjectDetails.graphql').definitions));


      module.exports = doc;
    
